import { getRuntimeConfigOrDefault } from '../utils/runtime-config';

// API base URL configuration with runtime support
const defaultApiUrl = process.env.NODE_ENV === 'production'
  ? 'https://jobometry-backend-g56h72tpva-uc.a.run.app/api/v1'
  : 'https://jobometry-backend-g56h72tpva-uc.a.run.app/api/v1';

export const API_BASE_URL = getRuntimeConfigOrDefault('REACT_APP_API_URL', defaultApiUrl);

// Verification service URL
const defaultVerificationUrl = 'https://verification-service-prod-547646866154.us-central1.run.app/api/v1';
export const VERIFICATION_API_URL = getRuntimeConfigOrDefault('REACT_APP_VERIFICATION_URL', defaultVerificationUrl);

// Common API headers
export const API_HEADERS = {
  'Content-Type': 'application/json',
};

// Vacancy API paths (relative to API_BASE_URL)
export const VACANCY_ENDPOINTS = {
  list: '/vacancies',
  detail: (id: string) => `/vacancies/${id}`,
  create: '/vacancies',
  update: (id: string) => `/vacancies/${id}`,
  close: (id: string) => `/vacancies/${id}`,
  refer: (id: string) => `/vacancies/${id}/refer`,
  myReferrals: '/vacancies/referrals/mine',
};
